import DefaultSignupStrategy from './defaultSignupStrategy';

const background = require('../../../../../assets/images/suunto-bg.jpg');
const logo = require('../../../../../assets/images/suunto-bg-logo.png');

export default class SuuntoSignupStrategy extends DefaultSignupStrategy {
  constructor(props) {
    super(props);

    this.isDefault = false;
    this.hasLogo = true;
    this.logo = logo;
    this.logoAltText = 'Suunto';
    this.pageClass = 'col-8 card card-signup suunto';
    this.header = 'Welcome Suunto Device Users';
    this.headline = `You are receiving a free 60 day trial of PWR Lab, courtesy of Suunto.
              PWR Lab is an easy-to-use but immensely powerful tool for enhancing your
              training and reducing your risk of injury. Sign up, sync your Suunto device,
              and get started!`;

    this.showCoupon = false;
    this.pageStyle = '';
    this.h3Style = 'margin-bottom: 20px;';
    this.logoStyle = 'background: rgba(255, 255, 255, 0.3); width: 65vw; max-width: 728px;';
    this.rootStyle = `
      background-image: url(${background});
      background-size: cover;
      background-attachment: initial;
      overflow-y: initial;
  `.replace(/\n/g, '');
  }
}
